<template>
  <div>
    <div
      class="rounded-md p-2 border border-solid"
      :class="getInputErrorClass(v.values.$dirty, v.values.$error)"
    >
      <div class="flex items-center">
        <div class="multiselect-wrap--small w-[200px] mr-1 flex-shrink-0">
          <multiselect
            :open-direction="isActions ? 'top' : 'bottom'"
            v-model="selectedAttribute"
            :options="formattedAttributeOptions"
            :group-values="groupedFilters ? 'options' : undefined"
            :group-label="groupedFilters ? 'label' : undefined"
            track-by="value"
            label="label"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            placeholder="Select attribute"
            :max-height="160"
            selected-label=""
            select-label=""
            deselect-label=""
            @input="handleAttributeChange"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <span
                v-tooltip.top-start="
                  option.label && option.label.length > 22 ? option.label : ''
                "
                class="single-label-text"
              >
                {{ option.label }}
              </span>
            </template>
            <template slot="option" slot-scope="{ option }">
              <strong v-if="option.$isLabel">
                {{ option.$groupLabel }}
              </strong>
              <span
                v-else
                v-tooltip.top-start="
                  option.label && option.label.length > 22 ? option.label : ''
                "
                class="option-label-text"
                :class="{
                  'option--disabled': option.$isDisabled || option.disabled,
                }"
              >
                {{ option.label }}
              </span>
            </template>
          </multiselect>
        </div>

        <div
          v-if="!shouldHideOperatorSelect"
          class="multiselect-wrap--small w-[150px] mr-1 flex-shrink-0"
        >
          <multiselect
            :open-direction="isActions ? 'top' : 'bottom'"
            v-model="selectedOperator"
            :options="formattedOperators"
            label="label"
            track-by="value"
            :allow-empty="false"
            :max-height="160"
            selected-label=""
            select-label=""
            deselect-label=""
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <span
                v-tooltip.top-start="
                  option.label && option.label.length > 14 ? option.label : ''
                "
                class="single-label-text"
                >{{ option.label }}</span
              >
            </template>
            <template slot="option" slot-scope="{ option }">
              <span
                v-tooltip.top-start="
                  option.label && option.label.length > 14 ? option.label : ''
                "
                class="option-label-text"
                >{{ option.label }}</span
              >
            </template>
          </multiselect>
        </div>

        <div
          v-if="inputType === 'meeting_present'"
          class="filter__answer--wrap mr-1 flex-1 min-w-0"
        >
          <div class="multiselect-wrap--small">
            <multiselect
              :open-direction="isActions ? 'top' : 'bottom'"
              v-model="meetingPresentSelection"
              track-by="id"
              label="name"
              placeholder="Select"
              :options="meetingPresentOptions"
              :allow-empty="false"
              :max-height="160"
              selected-label=""
              select-label=""
              deselect-label=""
            />
          </div>
        </div>

        <div
          v-else-if="showUserInput && inputType !== 'ai_generated_email'"
          class="filter__answer--wrap mr-1 flex-1 min-w-0"
        >
          <div
            v-if="inputType === 'multi_select'"
            class="multiselect-wrap--small condition-multiselect"
          >
            <multiselect
              :open-direction="isActions ? 'top' : 'bottom'"
              v-model="values"
              track-by="id"
              label="name"
              :placeholder="'Select'"
              :multiple="true"
              selected-label=""
              select-label=""
              deselect-label=""
              :max-height="160"
              :options="dropdownValues"
              :allow-empty="false"
              :limit="3"
              :limit-text="limitText"
            >
              <template slot="option" slot-scope="{ option }">
                <span
                  v-tooltip.top-start="
                    option.name && option.name.length > 20 ? option.name : ''
                  "
                  class="option-label-text"
                  >{{ option.name }}</span
                >
              </template>
            </multiselect>
          </div>
          <!-- <div
            v-else-if="inputType === 'search_select'"
            :class="attributeKey === 'board_id' ? 'board_pipeline_select_wrap multiselect-wrap--small' : 'multiselect-wrap--small'"
          >
            <multiselect
              v-model="values"
              track-by="id"
              label="name"
              :placeholder="'Select board'"
              selected-label
              select-label=""
              deselect-label=""
              :max-height="160"
              :options="dropdownValues"
              :allow-empty="falstatusValuesse"
              :option-height="104"
            />

            <div
              v-if="attributeKey === 'board_id'"
              class="multiselect-wrap--small"
            >
              <multiselect
                v-model="statusValues"
                track-by="id"
                label="name"
                placeholder="Select pipeline"
                selected-label
                select-label=""
                deselect-label=""
                :max-height="160"
                :options="dropdownStatusValues"
                :allow-empty="false"
                :option-height="104"
              />
            </div>
            
          </div> -->
          <div
            v-else-if="inputType === 'search_select'"
            :class="[
              'multiselect-wrap--small items-center',
              {
                board_pipeline_select_wrap: [
                  'board_id',
                  'prev_status_id',
                  'last_activity_by',
                  'campaign_id',
                ].includes(attributeKey),
              },
            ]"
          >
            <!-- Main select -->
            <multiselect
              :open-direction="isActions ? 'top' : 'bottom'"
              v-model="values"
              track-by="id"
              label="name"
              :placeholder="getPlaceholder"
              selected-label
              select-label=""
              deselect-label=""
              :max-height="160"
              :options="dropdownValues"
              :allow-empty="false"
              :option-height="104"
              :multiple="
                (attributeKey === 'assignee_id' && this.isActions) ||
                  (attributeKey === 'labels_id' && this.isActions)
              "
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <span
                  v-tooltip.top-start="
                    option.name && option.name.length > 20 ? option.name : ''
                  "
                  class="single-label-text"
                  >{{ option.name }}</span
                >
              </template>
              <template slot="option" slot-scope="{ option }">
                <span
                  v-tooltip.top-start="
                    option.name && option.name.length > 20 ? option.name : ''
                  "
                  class="option-label-text"
                  >{{ option.name }}</span
                >
              </template>
            </multiselect>

            <!-- Extra dropdown for board_id -->
            <div
              v-if="attributeKey === 'board_id'"
              class="multiselect-wrap--small pipeline-multiselect"
            >
              <multiselect
                :open-direction="isActions ? 'top' : 'bottom'"
                v-model="statusValues"
                track-by="id"
                label="name"
                placeholder="Select pipeline"
                selected-label
                select-label=""
                deselect-label=""
                :max-height="160"
                :options="dropdownStatusValues"
                :allow-empty="true"
                :option-height="104"
                :multiple="isStatusMulti"
                :limit="1"
                :limit-text="limitText"
                :class="{
                  'has-multiple':
                    Array.isArray(statusValues) && statusValues.length > 1,
                }"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <span
                    v-tooltip.top-start="
                      option.name && option.name.length > 20 ? option.name : ''
                    "
                    class="single-label-text"
                    >{{ option.name }}</span
                  >
                </template>
                <template slot="option" slot-scope="{ option }">
                  <span
                    v-tooltip.top-start="
                      option.name && option.name.length > 20 ? option.name : ''
                    "
                    class="option-label-text"
                    >{{ option.name }}</span
                  >
                </template>
              </multiselect>
            </div>

            <!-- Extra dropdown for campaign_id -->
            <div
              v-if="attributeKey === 'campaign_id'"
              class="multiselect-wrap--small pipeline-multiselect"
            >
              <multiselect
                :open-direction="isActions ? 'top' : 'bottom'"
                v-model="statusValues"
                track-by="id"
                label="name"
                placeholder="Select status"
                selected-label
                select-label=""
                deselect-label=""
                :max-height="160"
                :options="dropdownStatusValues"
                :allow-empty="true"
                :option-height="104"
                :multiple="isStatusMulti"
                :limit="1"
                :limit-text="limitText"
                :class="{
                  'has-multiple':
                    Array.isArray(statusValues) && statusValues.length > 1,
                }"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <span
                    v-tooltip.top-start="
                      option.name && option.name.length > 20 ? option.name : ''
                    "
                    class="single-label-text"
                    >{{ option.name }}</span
                  >
                </template>
                <template slot="option" slot-scope="{ option }">
                  <span
                    v-tooltip.top-start="
                      option.name && option.name.length > 20 ? option.name : ''
                    "
                    class="option-label-text"
                    >{{ option.name }}</span
                  >
                </template>
              </multiselect>
            </div>

            <!-- Extra dropdown for prev_status_id -->
            <div
              v-if="attributeKey === 'prev_status_id'"
              class="multiselect-wrap--small"
            >
              <multiselect
                :open-direction="isActions ? 'top' : 'bottom'"
                v-model="previousStateValues"
                track-by="id"
                label="name"
                placeholder="Select previous status"
                selected-label
                select-label=""
                deselect-label=""
                :max-height="160"
                :options="dropdownPreviousStateValues || []"
                :allow-empty="false"
                :option-height="104"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <span
                    v-tooltip.top-start="
                      option.name && option.name.length > 20 ? option.name : ''
                    "
                    class="single-label-text"
                    >{{ option.name }}</span
                  >
                </template>
                <template slot="option" slot-scope="{ option }">
                  <span
                    v-tooltip.top-start="
                      option.name && option.name.length > 20 ? option.name : ''
                    "
                    class="option-label-text"
                    >{{ option.name }}</span
                  >
                </template>
              </multiselect>
            </div>

            <!-- Extra dropdown for last_activity_by -->
            <div
              v-if="attributeKey === 'last_activity_by'"
              class="multiselect-wrap--small"
            >
              <!-- Select Date -->
              <div class="date-picker">
                <date-picker
                  :range="true"
                  :confirm="true"
                  :clearable="false"
                  :editable="false"
                  :confirm-text="confirmText"
                  :placeholder="placeholder"
                  :value="value"
                  @change="handleDateChange"
                  v-model="selectedDate"
                  :get-class="highlightToday"
                  :disabled-date="disableFutureDates"
                />
              </div>
            </div>
          </div>

          <!-- <div v-else-if="inputType === 'date'" class="multiselect-wrap--small">
            <input
              v-model="values"
              type="date"
              :editable="false"
              class="mb-0 datepicker"
            />
          </div> -->
          <div
            v-else-if="inputType === 'date' || inputType === 'datetime'"
            class="multiselect-wrap--small flex items-center justify-center gap-1 flex-wrap"
          >
            <input
              v-model="values"
              :type="getDateInputType()"
              :editable="false"
              :max="attributeKey === 'created_at' ? createdAtMaxDateTime() : undefined"
              :class="[
                'mb-0 datepicker',
                inputType === 'datetime' && filterOperator === 'between'
                  ? 'flex-1 min-w-[10rem] max-w-[50%]'
                  : '',
              ]"
              :step="inputType === 'datetime' ? '1' : undefined"
            />

            <input
              v-if="inputType === 'datetime' && filterOperator === 'between'"
              v-model="values2"
              :type="getDateInputType()"
              :editable="false"
              :max="attributeKey === 'created_at' ? createdAtMaxDateTime() : undefined"
              class="mb-0 datepicker flex-1 min-w-[10rem] max-w-[50%]"
              :step="inputType === 'datetime' ? '1' : undefined"
            />
          </div>

          <input
            v-else-if="attributeKey === 'lead_quality_score'"
            :value="leadQualityScoreInputDisplay"
            type="number"
            min="1"
            max="100"
            step="1"
            class="mb-0"
            placeholder="1-100"
            @input="onLeadQualityScoreConditionInput"
          />
          <input
            v-else-if="attributeKey === 'reengagement_count'"
            :value="reengagementCountInputDisplay"
            type="number"
            min="0"
            step="1"
            class="mb-0"
            placeholder="0"
            @input="onReengagementCountConditionInput"
          />
          <input
            v-else-if="isRelativeTimeBeforeOperator"
            :value="relativeTimeBeforeInputDisplay"
            type="number"
            min="1"
            :max="relativeTimeBeforeMax"
            step="1"
            class="mb-0"
            :placeholder="relativeTimeBeforePlaceholder"
            @input="onRelativeTimeBeforeInput"
          />
          <input
            v-else
            v-model="values"
            type="text"
            class="mb-0"
            placeholder="Enter value"
            @input="validatePhoneNumberAndEmail"
          />
        </div>
        <woot-button
          icon="dismiss"
          variant="clear"
          color-scheme="secondary"
          class="flex-shrink-0"
          @click="removeFilter"
        />
      </div>
      <automation-action-ai-generated-email-input
        v-if="inputType === 'ai_generated_email'"
        class="ai-email-action"
        :value="aiEmailValue"
        :show-action-select="false"
        :show-remove="false"
        @input="onAiEmailInput"
      />
      <p
        v-if="
          v.values.$dirty &&
            v.values.$error &&
            !phoneNumberError2 &&
            !validEmailError2 &&
            !hoursBeforeRangeError &&
            inputType !== 'ai_generated_email'
        "
        class="filter-error"
      >
        {{ $t('FILTER.EMPTY_VALUE_ERROR') }}
      </p>
      <p v-if="aiEmailErrorMessage" class="filter-error">
        {{ aiEmailErrorMessage }}
      </p>
      <p v-if="hoursBeforeRangeError" class="filter-error">
        {{ $t('FILTER.LAST_X_HOURS_RANGE_ERROR') }}
      </p>
      <p v-if="phoneNumberError2" class="filter-error">
        {{ phoneNumberErrorMessage }}
      </p>
      <p v-if="validEmailError2" class="filter-error">
        Please enter a valid email
      </p>
    </div>

    <div
      v-if="showQueryOperator"
      class="flex items-center justify-center relative my-2.5 mx-0"
    >
      <hr
        class="w-full absolute border-b border-solid border-slate-75 dark:border-slate-800"
      />
      <select
        v-model="query_operator"
        class="bg-white dark:bg-slate-900 mb-0 w-auto relative text-slate-800 dark:text-slate-100 border-slate-75 dark:border-slate-600"
      >
        <option value="and">
          {{ $t('FILTER.QUERY_DROPDOWN_LABELS.AND') }}
        </option>
        <option value="or">
          {{ $t('FILTER.QUERY_DROPDOWN_LABELS.OR') }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import AutomationActionAiGeneratedEmailInput from 'dashboard/components/widgets/AutomationActionAiGeneratedEmailInput.vue';
import {
  aiEmailConfigErrorCode,
  aiEmailErrorBounds,
  aiEmailErrorI18nKey,
  defaultAiEmailActionValue,
} from 'dashboard/helper/aiEmailSchedule';
export default {
  components: {
    DatePicker,
    AutomationActionAiGeneratedEmailInput,
  },
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    filterAttributes: {
      type: Array,
      default: () => [],
    },
    inputType: {
      type: String,
      default: 'plain_text',
    },
    dataType: {
      type: String,
      default: 'plain_text',
    },
    operators: {
      type: Array,
      default: () => [],
    },
    operatorTranslationKey: {
      type: String,
      default: 'FILTER.OPERATOR_LABELS',
    },
    dropdownValues: {
      type: Array,
      default: () => [],
    },
    showQueryOperator: {
      type: Boolean,
      default: false,
    },
    v: {
      type: Object,
      default: () => null,
    },
    showUserInput: {
      type: Boolean,
      default: true,
    },
    groupedFilters: {
      type: Boolean,
      default: false,
    },
    filterGroups: {
      type: Array,
      default: () => [],
    },
    customAttributeType: {
      type: String,
      default: '',
    },
    statusValue: {
      type: Object,
      default: () => null,
    },
    placeholder: {
      type: String,
      default: 'Select date',
    },
    isActions: {
      type: Boolean,
      default: false,
    },
    hideOperatorSelect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      phoneNumberError2: false,
      validEmailError2: false,
      dropdownStatusValues: [],
      // statusValues: "",
      selectedDate: null,
      localValues2: null,
      selectedAttribute: null,
      previousSelectedAttribute: null,
    };
  },
  watch: {
    customAttributeType: {
      handler(value) {
        if (
          value === 'conversation_attribute' ||
          value === 'contact_attribute'
        ) {
          this.value.custom_attribute_type = this.customAttributeType;
        } else this.value.custom_attribute_type = '';
      },
      immediate: true,
    },
    values: 'validatePhoneNumberAndEmail',
    'value.filter_operator': 'validatePhoneNumberAndEmail',
    value: {
      immediate: true,
      handler(newVal) {
        if (
          newVal?.attribute_key !== 'board_id' &&
          newVal?.attribute_key !== 'prev_status_id' &&
          newVal?.attribute_key !== 'campaign_id'
        ) {
          return;
        }
        let boardId = null;
        let campaignId = null;

        if (Array.isArray(newVal.values)) {
          boardId = newVal.values[0]?.id || newVal.values[0];
          campaignId = newVal.values[0]?.id || newVal.values[0];
        } else if (typeof newVal.values === 'object') {
          boardId = newVal.values?.id;
          campaignId = newVal.values?.id;
        } else {
          boardId = newVal.values;
          campaignId = newVal.values;
        }

        // Handle board statuses
        if (
          newVal?.attribute_key === 'board_id' ||
          newVal?.attribute_key === 'prev_status_id'
        ) {
          // First check if the value object already has statuses_attributes (from saved segment)
          let statusesFromValue = null;
          if (
            typeof newVal.values === 'object' &&
            newVal.values?.statuses_attributes
          ) {
            statusesFromValue = newVal.values.statuses_attributes;
          }

          boardId = String(boardId);
          const selectedBoard = this.dropdownValues.find(board => {
            return String(board?.id) === boardId;
          });

          // Use statuses from value object if available, otherwise from dropdown
          if (statusesFromValue) {
            this.dropdownStatusValues = statusesFromValue;
          } else if (selectedBoard?.statuses_attributes) {
            this.dropdownStatusValues = selectedBoard.statuses_attributes;
          } else {
            this.dropdownStatusValues = [];
          }

          if (newVal?.attribute_key === 'prev_status_id') {
            if (statusesFromValue) {
              this.dropdownPreviousStateValues = statusesFromValue;
            } else if (selectedBoard?.statuses_attributes) {
              this.dropdownPreviousStateValues =
                selectedBoard.statuses_attributes;
            } else {
              this.dropdownPreviousStateValues = [];
            }
          }
        }

        // Handle campaign statuses
        if (newVal?.attribute_key === 'campaign_id') {
          // First check if the value object already has statuses_attributes (from saved segment)
          let statusesFromValue = null;
          if (
            typeof newVal.values === 'object' &&
            newVal.values?.statuses_attributes
          ) {
            statusesFromValue = newVal.values.statuses_attributes;
          }

          campaignId = String(campaignId);
          const selectedCampaign = this.dropdownValues.find(campaign => {
            return String(campaign?.id) === campaignId;
          });

          // Use statuses from value object if available, otherwise from dropdown
          if (statusesFromValue) {
            this.dropdownStatusValues = statusesFromValue;
          } else if (selectedCampaign?.statuses_attributes) {
            this.dropdownStatusValues = selectedCampaign.statuses_attributes;
          } else {
            this.dropdownStatusValues = [];
          }
        }
      },
    },
    'value.attribute_key': {
      immediate: true,
      handler(key) {
        this.resolveSelectedAttribute(key);
      },
    },
    formattedAttributeOptions: {
      immediate: true,
      handler() {
        // Re-resolve when options become available (e.g. editing a saved filter)
        if (this.value?.attribute_key) {
          this.resolveSelectedAttribute(this.value.attribute_key);
        }
      },
    },
  },
  computed: {
    isStatusMulti() {
      const accountId = this.$route?.params?.accountId;
      const path = this.$route?.path || '';
      if (!accountId) return !this.isActions;

      const base = `/app/accounts/${accountId}/contacts`;
      const isContactsRoute = path === base || path.startsWith(`${base}/`);
      return isContactsRoute && !this.isActions;
    },
    leadQualityScoreInputDisplay() {
      if (this.attributeKey !== 'lead_quality_score') return '';
      const v = this.value?.values;
      const raw = Array.isArray(v) ? v[0] : v;
      if (raw === '' || raw === null || raw === undefined) return '';
      const n = Number(raw);
      if (!Number.isFinite(n)) return '';
      return String(Math.max(1, Math.min(100, Math.trunc(n))));
    },
    reengagementCountInputDisplay() {
      if (this.attributeKey !== 'reengagement_count') return '';
      const v = this.value?.values;
      const raw = Array.isArray(v) ? v[0] : v;
      if (raw === '' || raw === null || raw === undefined) return '';
      const n = Number(raw);
      if (!Number.isFinite(n) || n < 0) return '';
      return String(Math.trunc(n));
    },
    isRelativeTimeBeforeOperator() {
      return (
        this.filterOperator === 'days_before' ||
        this.isLastXHoursOperator
      );
    },
    isLastXHoursOperator() {
      return this.filterOperator === 'last_x_hours';
    },
    relativeTimeBeforeMax() {
      return this.isLastXHoursOperator ? 24 : 998;
    },
    relativeTimeBeforePlaceholder() {
      return this.isLastXHoursOperator ? '1-24' : '1-998';
    },
    relativeTimeBeforeInputDisplay() {
      if (!this.isRelativeTimeBeforeOperator) return '';
      const v = this.value?.values;
      const raw = Array.isArray(v) ? v[0] : v;
      if (raw === '' || raw === null || raw === undefined) return '';
      const n = Number(raw);
      if (!Number.isFinite(n)) return '';
      return String(Math.trunc(n));
    },
    hoursBeforeRangeError() {
      if (!this.isLastXHoursOperator) return false;

      const raw = Array.isArray(this.value?.values)
        ? this.value.values[0]
        : this.value?.values;
      if (raw === '' || raw === null || raw === undefined) return false;

      const hours = Number(raw);
      return !Number.isInteger(hours) || hours < 1 || hours > 24;
    },
    phoneNumberErrorMessage() {
      const op = this.filterOperator;
      if (op === 'contains' || op === 'does_not_contain') {
        const digitCount = ((this.values || '').match(/\d/g) || []).length;
        if (digitCount > 16) {
          return 'Phone number cannot exceed 16 digits';
        }
        return 'Please enter a valid phone number';
      }
      return 'Please enter a valid phone number with country code';
    },
    aiEmailValue() {
      const raw = this.value?.values;
      if (raw && typeof raw === 'object' && !Array.isArray(raw)) return raw;
      return defaultAiEmailActionValue();
    },
    aiEmailErrorMessage() {
      if (this.inputType !== 'ai_generated_email') return '';
      if (!this.v?.values?.$dirty || !this.v?.values?.$error) return '';
      const code = aiEmailConfigErrorCode(this.value?.values);
      const key = aiEmailErrorI18nKey(code);
      if (!key) return this.$t('FILTER.EMPTY_VALUE_ERROR');
      const bounds = aiEmailErrorBounds(code);
      return this.$t(key, {
        min: bounds.MIN,
        max: bounds.MAX,
      });
    },
    attributeKey: {
      get() {
        if (!this.value) return null;
        return this.value.attribute_key;
      },
      set(value) {
        const payload = this.value || {};
        this.$emit('input', { ...payload, attribute_key: value });
      },
    },
    filterOperator: {
      get() {
        if (!this.value) return null;
        return this.value.filter_operator;
      },
      set(value) {
        const payload = this.value || {};
        let next = { ...payload, filter_operator: value };
        if (this.inputType === 'datetime') {
          if (value === 'between') {
            const first = Array.isArray(payload.values)
              ? payload.values[0]
              : payload.values || null;
            const second = Array.isArray(payload.values)
              ? payload.values[1]
              : null;
            next = { ...next, values: [first, second] };
          } else {
            const first = Array.isArray(payload.values)
              ? payload.values[0]
              : payload.values || null;
            next = { ...next, values: first };
          }
        }
        this.$emit('input', next);
      },
    },
    values: {
      get() {
        if (!this.value) return null;
        if (
          this.value.attribute_key === 'last_activity_by' &&
          this.value.selectedDate
        ) {
          this.selectedDate = this.value.selectedDate?.map(d => new Date(d));
        }
        if (
          this.inputType === 'datetime' &&
          this.filterOperator === 'between'
        ) {
          const vals = this.value.values;
          if (Array.isArray(vals)) {
            return this.formatDateTimeForInput(vals[0]) || null;
          }
        }
        // For datetime inputs, ensure the value is in the correct format (YYYY-MM-DDTHH:mm)
        if (this.inputType === 'datetime' || this.inputType === 'date') {
          return this.formatDateTimeForInput(this.value.values);
        }
        return this.value.values;
      },
      set(value) {
        const payload = this.value || {};
        if (this.value.attribute_key == 'board_id') {
          this.dropdownStatusValues = value?.statuses_attributes;
        }

        if (this.value.attribute_key == 'prev_status_id') {
          this.dropdownPreviousStateValues = value?.statuses_attributes;
        }

        if (this.value.attribute_key == 'campaign_id') {
          this.dropdownStatusValues = value?.statuses_attributes;
        }

        if (this.value.attribute_key === 'last_activity_by') {
          this.$emit('input', {
            ...payload,
            values: value,
            statusValues: this.isActions ? null : [],
          });
          return;
        }

        if (
          this.inputType === 'datetime' &&
          this.filterOperator === 'between'
        ) {
          const combined = [value, this.values2].filter(
            v => v !== null && v !== undefined && v !== ''
          );
          this.$emit('input', {
            ...payload,
            values: combined,
            statusValues: this.isActions ? null : [],
          });
          return;
        }

        this.$emit('input', {
          ...payload,
          values: value,
          statusValues: this.isActions ? null : [],
        });
      },
    },
    values2: {
      get() {
        if (!this.value) return null;
        if (
          this.inputType === 'datetime' &&
          this.filterOperator === 'between' &&
          Array.isArray(this.value.values)
        ) {
          return this.formatDateTimeForInput(this.value.values[1]) || null;
        }
        return this.value.values2;
      },
      set(value) {
        const payload = this.value || {};
        if (
          this.inputType === 'datetime' &&
          this.filterOperator === 'between'
        ) {
          const first = this.values;
          const combined = [first, value].filter(
            v => v !== null && v !== undefined && v !== ''
          );
          this.$emit('input', { ...payload, values: combined });
          return;
        }
        // ignore if not between
        this.$emit('input', { ...payload, values: this.values });
      },
    },
    statusValues: {
      get() {
        if (!this.value) return this.isStatusMulti ? [] : null;
        const val = this.value.statusValues;
        return this.isStatusMulti
          ? Array.isArray(val)
            ? val
            : []
          : val || null;
      },
      set(value) {
        const payload = this.value || {};
        this.$emit('input', { ...payload, statusValues: value });
      },
    },

    query_operator: {
      get() {
        if (!this.value) return null;
        return this.value.query_operator;
      },
      set(value) {
        const payload = this.value || {};
        this.$emit('input', { ...payload, query_operator: value });
      },
    },
    custom_attribute_type: {
      get() {
        if (!this.customAttributeType) return '';
        return this.customAttributeType;
      },
      set() {
        const payload = this.value || {};
        this.$emit('input', {
          ...payload,
          custom_attribute_type: this.customAttributeType,
        });
      },
    },
    getPlaceholder() {
      console.log('attributeKey', this.attributeKey);
      if (this.attributeKey === 'board_id') return 'Select board';
      if (this.attributeKey === 'prev_status_id') return 'Select board';
      if (this.attributeKey === 'campaign_id') return 'Select campaign';
      if (this.attributeKey === 'send_conversion_event')
        return this.$t('CONTACTS_FILTER.CAPI_EVENT_PLACEHOLDER');
      return 'Select option';
    },
    previousStateValues: {
      get() {
        return this.value?.previousStateValues || null;
      },
      set(val) {
        console.log('previousStateValues', this.value);
        this.$emit('input', { ...this.value, previousStateValues: val });
      },
    },
    selectedDate: {
      get() {
        return this.value?.selectedDate || null; // <-- store/retrieve from value
      },
      set(val) {
        console.log('selectedDate set ->', val, this.value);
        this.$emit('input', {
          ...this.value,
          selectedDate: val, // <-- use val, not this.selectedDate
        });
      },
    },
    formattedAttributeOptions() {
      if (this.groupedFilters) {
        return this.filterGroups.map(group => ({
          label: group.name,
          options: group.attributes.map(attr => ({
            label: attr.name,
            value: attr.key,
            disabled: attr.disabled || false,
            $isDisabled: attr.disabled || false,
          })),
        }));
      }

      return this.filterAttributes.map(attr => ({
        label: attr.name,
        value: attr.key,
        disabled: attr.disabled || false,
        $isDisabled: attr.disabled || false,
      }));
    },
    formattedOperators() {
      return (this.operators || []).map(op => ({
        label: this.$t(`${this.operatorTranslationKey}.${op.value}`),
        value: op.value,
      }));
    },
    shouldHideOperatorSelect() {
      return (
        this.hideOperatorSelect || this.attributeKey === 'meeting_present'
      );
    },
    meetingPresentOptions() {
      return [
        { id: 'yes', name: 'Yes' },
        { id: 'no', name: 'No' },
      ];
    },
    meetingPresentSelection: {
      get() {
        const op = this.value?.filter_operator;
        const id = op === 'is_not_present' ? 'no' : 'yes';
        return (
          this.meetingPresentOptions.find(option => option.id === id) ||
          this.meetingPresentOptions[0]
        );
      },
      set(option) {
        const payload = this.value || {};
        const isYes = option?.id !== 'no';
        this.$emit('input', {
          ...payload,
          filter_operator: isYes ? 'is_present' : 'is_not_present',
          values: isYes ? 'yes' : 'no',
        });
      },
    },
    selectedOperator: {
      get() {
        return (
          this.formattedOperators.find(
            op => op.value === this.value.filter_operator
          ) || null
        );
      },
      set(option) {
        if (!option?.value) return;
        this.$emit('input', {
          ...this.value,
          filter_operator: option.value,
        });
      },
    },
  },

  methods: {
    resolveSelectedAttribute(key) {
      if (!key) {
        this.selectedAttribute = null;
        return;
      }
      const options = this.formattedAttributeOptions;
      const found = options.reduce((result, opt) => {
        if (result) return result;
        if (opt.options) {
          return opt.options.find(o => o.value === key) || null;
        }
        return opt.value === key ? opt : null;
      }, null);

      if (found || options.length > 0) {
        this.selectedAttribute = found;
      }
    },
    onLeadQualityScoreConditionInput(e) {
      const raw = e.target.value;
      if (raw === '' || raw === null) {
        this.values = '';
        return;
      }
      const n = parseInt(raw, 10);
      if (Number.isNaN(n)) {
        this.values = '';
        return;
      }
      this.values = String(Math.max(1, Math.min(100, n)));
    },
    onReengagementCountConditionInput(e) {
      const raw = e.target.value;
      if (raw === '' || raw === null) {
        this.values = '';
        return;
      }
      const n = parseInt(raw, 10);
      if (Number.isNaN(n)) {
        this.values = '';
        return;
      }
      this.values = String(Math.max(0, n));
    },
    onRelativeTimeBeforeInput(e) {
      const raw = e.target.value;
      if (raw === '' || raw === null) {
        this.values = '';
        return;
      }
      const digitsOnly = String(raw).replace(/\D/g, '');
      if (digitsOnly === '') {
        this.values = '';
        return;
      }
      const n = parseInt(digitsOnly, 10);
      if (Number.isNaN(n)) {
        this.values = '';
        return;
      }
      this.values = String(n);
    },
    validatePhoneNumberAndEmail() {
      this.phoneNumberError2 = false;
      this.$emit('phoneNumberError', false);
      this.validEmailError2 = false;
      this.$emit('validEmailError', false);

      if (this.attributeKey === 'phone_number') {
        const op = this.filterOperator;
        if (op === 'contains' || op === 'does_not_contain') {
          // Allow partial phone substrings but disallow alphabets.
          const partialPhoneRegex = /^[\d\s+().-]*$/;
          const raw = this.values || '';
          const digitCount = (raw.match(/\d/g) || []).length;
          const isValid = partialPhoneRegex.test(raw) && digitCount <= 16;
          this.phoneNumberError2 = !isValid;
          this.$emit('phoneNumberError', !isValid);
          return;
        }

        // const phoneRegex = /^[0-9]*$/;
        // const phoneRegex = /^\+?\d{1,4}?[\s.-]?\(?\d{1,4}?\)?[\s.-]?\d{1,4}[\s.-]?\d{1,4}$/;
        // const phoneRegex = /^\+\d{1,4}[\s.-]?\(?\d{2,5}\)?[\s.-]?\d{3,5}[\s.-]?\d{3,5}$/;
        const phoneRegex = /^\+\d{1,4}[\s.-]?[\d\s().-]{4,20}$/;

        if (!phoneRegex.test(this.values)) {
          this.phoneNumberError2 = true;
          this.$emit('phoneNumberError', true);
        } else {
          this.phoneNumberError2 = false;
          this.$emit('phoneNumberError', false);
        }
      } else if (this.attributeKey === 'email') {
        const op = this.filterOperator;
        if (op === 'contains' || op === 'does_not_contain') {
          this.validEmailError2 = false;
          this.$emit('validEmailError', false);
          return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!this.values) {
          this.$emit('validEmailError', false);
          this.validEmailError2 = false;
        } else if (!emailRegex.test(this.values)) {
          this.validEmailError2 = true;
          this.$emit('validEmailError', true);
        } else {
          this.$emit('validEmailError', false);
          this.validEmailError2 = false;
        }
      }
    },
    removeFilter() {
      this.$emit('removeFilter');
    },
    onAiEmailInput(config) {
      const payload = this.value || {};
      this.$emit('input', {
        ...payload,
        filter_operator: 'equal_to',
        values: config,
      });
    },
    resetFilter() {
      this.$emit('resetFilter');
    },
    getInputErrorClass(isDirty, hasError) {
      return isDirty && hasError
        ? 'bg-red-50 dark:bg-red-800/50 border-red-100 dark:border-red-700/50'
        : 'bg-slate-50 dark:bg-slate-800 border-slate-75 dark:border-slate-700/50';
    },
    getDateInputType() {
      if (this.inputType === 'datetime') {
        return 'datetime-local';
      }
      return 'date';
    },
    // Max date/time for "Created At" — disables future dates (creation cannot be in the future)
    createdAtMaxDateTime() {
      if (this.attributeKey !== 'created_at') return undefined;
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      if (this.inputType === 'datetime') {
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
      }
      return `${year}-${month}-${day}`;
    },
    formatDateTimeForInput(value) {
      // Format datetime values for HTML datetime-local input (YYYY-MM-DDTHH:mm)
      // or date input (YYYY-MM-DD)
      if (!value) return null;

      // If it's already a properly formatted string for the input, return as-is
      if (typeof value === 'string') {
        // For datetime-local: expecting YYYY-MM-DDTHH:mm or YYYY-MM-DDTHH:mm:ss
        // For date: expecting YYYY-MM-DD

        // If the value contains a 'T' (datetime), ensure it's in correct format
        if (value.includes('T')) {
          // Remove timezone info (Z or +/-offset) and seconds if present for datetime-local
          const dateTimePart = value.split(/[Z+]|(?=[-+]\d{2}:)/)[0];
          // Take only YYYY-MM-DDTHH:mm (first 16 chars)
          if (this.inputType === 'datetime') {
            return dateTimePart.slice(0, 16);
          }
          // For date input, take only YYYY-MM-DD
          return dateTimePart.slice(0, 10);
        }

        // If it's just a date string (YYYY-MM-DD), return as-is
        return value;
      }

      return value;
    },
    handleDateChange(date) {
      this.selectedDate = date;
      let start_date = null;
      let end_date = null;
      if (this.value?.attribute_key === 'last_activity_by') {
        const formatToLocalDate = d => {
          if (!(d instanceof Date)) return null;
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, '0');
          const day = String(d.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        if (Array.isArray(date) && date.length === 2) {
          start_date = formatToLocalDate(date[0]);
          end_date = formatToLocalDate(date[1]);
        }

        const payload = this.value || {};
        this.$emit('input', {
          ...payload,
          values: payload.values || [],
          start_date: start_date,
          end_date: end_date,
          selectedDate: this.selectedDate,
          statusValues: this.isActions ? null : [],
        });
      }
    },
    limitText(count) {
      return `+${count}`;
    },
    handleAttributeChange(option) {
      // If nothing was selected (e.g. deselect), just save state and return
      if (!option) {
        this.previousSelectedAttribute = null;
        return;
      }

      // If the option is disabled, is a group heading, or has no value, revert
      if (
        option.disabled ||
        option.$isDisabled ||
        option.$isLabel ||
        !option.value
      ) {
        // Revert selectedAttribute back to what it was before this click
        this.$nextTick(() => {
          this.selectedAttribute = this.previousSelectedAttribute;
        });
        return;
      }

      // Save current as previous for future reverts
      this.previousSelectedAttribute = option;

      const payload = this.value || {};

      this.$emit('input', {
        ...payload,
        attribute_key: option.value,
        values: null,
        statusValues: null,
        previousStateValues: null,
      });

      // Clear local dropdowns
      this.dropdownStatusValues = [];
      this.dropdownPreviousStateValues = [];

      if (this.isActions) {
        this.$nextTick(() => {
          this.resetFilter();
        });
      } else {
        this.resetFilter();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.filter__answer--wrap {
  input {
    @apply bg-white dark:bg-slate-900 mb-0 text-slate-800 dark:text-slate-100 border-slate-75 dark:border-slate-600;
  }
}

.filter-error {
  @apply text-red-500 dark:text-red-200 block my-1 mx-0;
}

.ai-email-action {
  @apply mt-3 w-full;
}

.multiselect {
  @apply mb-0;
}
.date-picker {
  width: 150px;
}
.date-picker .mx-datepicker.mx-datepicker-range {
  width: 150px !important;
}
/* Prevent date text from appearing behind the calendar icon when long range is scrollable */
.date-picker ::v-deep(.mx-input-wrapper) {
  position: relative;
  box-sizing: border-box;
}
.date-picker ::v-deep(.mx-input) {
  margin-bottom: 0px !important;
  padding-right: 1.75rem !important;
  box-sizing: border-box;
}
::v-deep(.multiselect__option--highlight:not(.multiselect__option--selected)::after) {
  display: none !important;
}
</style>

<style lang="scss">
/* Prevent clicks on group heading labels */
.multiselect__option--group {
  pointer-events: none !important;
  cursor: default !important;
  background: none !important;
  color: inherit !important;
  font-weight: 700;
}
/* Prevent clicks on disabled options */
.multiselect__option--disabled {
  pointer-events: none !important;
  cursor: not-allowed !important;
  opacity: 0.6;
  background: #d5d5d5 !important;
  color: #777 !important;
}
/* Remove highlight styling from disabled options */
.multiselect__option--disabled.multiselect__option--highlight {
  background: #c0c0c0 !important;
  color: #777 !important;
}
/* Pipeline multiselect styles - unscoped to target nested multiselect component */
.pipeline-multiselect {
  /* Make pipeline selector same width as board selector */
  .multiselect {
    width: 200px !important;
    min-width: 200px !important;
  }

  .multiselect__tags {
    width: 200px !important;
  }

  /* When single item selected - show full text */
  .multiselect:not(.has-multiple) {
    .multiselect__tag {
      max-width: none;
      overflow: visible;
      text-overflow: unset;
    }
  }

  /* When multiple items selected - compact view with badge */
  .multiselect.has-multiple {
    .multiselect__tags {
      display: flex !important;
      align-items: center !important;
      flex-wrap: nowrap !important;
      overflow: hidden !important;
    }

    .multiselect__tags-wrap {
      display: flex !important;
      align-items: center !important;
      flex-wrap: nowrap !important;
      overflow: hidden !important;
      max-width: calc(100% - 70px);
    }

    .multiselect__tag {
      flex-shrink: 0;
      max-width: 90px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 4px !important;
    }
  }

  /* Badge styling for +N count */
  .multiselect__strong {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-left: 2px;
    margin-right: 4px;
    padding: 4px 10px;
    font-size: 13px;
    font-weight: 500;
    color: white;
    background-color: #1f93ff;
    border-radius: 12px;
    min-width: 28px;
    height: 24px;
    line-height: 1;
  }
}
/* Condition multiselect styles - fix overflow for status conditions */
.condition-multiselect {
  .multiselect {
    min-height: 40px;
  }

  .multiselect__tags {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    overflow: hidden;
    min-height: 40px;
    padding: 6px 40px 6px 8px;
  }

  .multiselect__tags-wrap {
    display: flex;
    align-items: center;
    gap: 4px;
    max-width: 100%;
    overflow: hidden;
    flex: 1;
  }

  .multiselect__tag {
    flex-shrink: 0;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0 !important;
    padding: 4px 26px 4px 10px;
    font-size: 13px;
    line-height: 1.2;
  }

  .multiselect__tag-icon {
    line-height: 1.4;
    width: 20px;
    text-align: center;
  }

  /* Badge styling for +N count */
  .multiselect__strong {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin: 0 4px;
    padding: 4px 10px;
    font-size: 13px;
    font-weight: 600;
    color: white;
    background-color: #1f93ff;
    border-radius: 12px;
    min-width: 32px;
    height: 26px;
    line-height: 1;
  }

  .multiselect__option span {
    width: auto !important;
    max-width: 100% !important;
  }

  .multiselect__option--selected {
    padding-right: 2.25rem !important;
  }
}

/* Ellipsis before green checkmark on selected filter dropdown options */
.multiselect__option--selected .option-label-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
</style>
